import { render, staticRenderFns } from "./GrowthIndex.vue?vue&type=template&id=0e7d2e44&"
import script from "./GrowthIndex.vue?vue&type=script&lang=js&"
export * from "./GrowthIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports